"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    incomingMessage: 'Inkommande meddelande' || 'incomingMessage',
    writeIncomingMessage: 'Skapa ett inkomande meddelande' || 'writeIncomingMessage',
    retry: 'Skicka om inkommande meddelande' || 'retry',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    integration: 'Integration' || 'integration',
    incoming: 'Kanal' || 'incoming',
    requestBodyS3Path: 'Inkommande meddelande' || 'requestBodyS3Path',
    keywords: 'Sökord' || 'keywords',
    mappedRequestS3Path: 'Mappningsresultat' || 'mappedRequestS3Path',
    hasFailedActionCalls: 'Misslyckade skrivningar' || 'hasFailedActionCalls',
};
